module.exports = __webpack_public_path__ + "static/img/foot_img.e307119.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/foot_img.png
// module id = y4Je
// module chunks = 128